import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import store, {persistor} from "./store/store";
import {AppSessionProvider} from "./app/layout/core/AppSession";
import {QueryClient, QueryClientProvider} from 'react-query';

// SASS IMPORT
import "./index.scss";

// CORE
import {AppI18nProvider} from "./app/i18n";
import {AppLayoutProvider, AppSplashScreenProvider} from "./app/layout";
import App from "./app/App";
import {ReactQueryDevtools} from "react-query/devtools";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env;

const queryClient = new QueryClient();

ReactDOM.render(
    <AppI18nProvider>
        <AppLayoutProvider>
            <AppSplashScreenProvider>
                <AppSessionProvider>
                    <QueryClientProvider client={queryClient}>
                        {/* APP */}
                        <App store={store} persistor={persistor} basename={PUBLIC_URL}/>

                        {/* React Query DEVTOOLS panel */}
                        <ReactQueryDevtools initialIsOpen/>
                    </QueryClientProvider>
                </AppSessionProvider>
            </AppSplashScreenProvider>
        </AppLayoutProvider>
    </AppI18nProvider>,
    document.getElementById("root")
);
